import React from "react";
import useNfuVs from "../../../hooks/administrador/recoleccion/useNfuVs";
import EchartsWrapper from "../../../pages/EchartsWrapper";
import '../../../styles/administrador.css';

const NfuVs = ({ year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada }) => {
  const { data, loading, error } = useNfuVs(
    year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada
  );
  
   
  if (loading) {
    return (
      <div className="grafica loading-container">
        <p>Cargando datos... Si tarda demasiado, intenta actualizar la página.</p>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="grafica error-container">
        <p>Error: {error}</p>
        <button onClick={() => window.location.reload()}>Intentar de nuevo</button>
      </div>
    );
  }
  
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="grafica empty-container">
        <p>No hay datos disponibles para los filtros seleccionados.</p>
        <p>Parámetros: Año={year}, Mes={mes},
          {provinciaSeleccionada ? ` Provincia=${provinciaSeleccionada}` : ""}
          {ciudadSeleccionada ? `, Ciudad=${ciudadSeleccionada}` : ""}
        </p>
      </div>
    );
  }
  
  const nombresMeses = {
    1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril', 5: 'Mayo', 6: 'Junio',
    7: 'Julio', 8: 'Agosto', 9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre'
  };
  
  const mesesNumericos = [...new Set(data.map(item => Number(item.Mes)))].sort((a, b) => a - b);
  const mesesFormateados = mesesNumericos.map(mes => nombresMeses[mes]?.substring(0, 3).toUpperCase() || `M${mes}`);
  
  const cantidadReportada = mesesNumericos.map(mes => {
    const item = data.find(d => Number(d.Mes) === mes);
    return item ? parseFloat(item.Cantidad_Reportada) || 0 : 0;
  });
  
  const cantidadRecolectada = mesesNumericos.map(mes => {
    const item = data.find(d => Number(d.Mes) === mes);
    return item ? parseFloat(item.Cantidad_Recolectada) || 0 : 0;
  });
  
  const totalReportados = cantidadReportada.reduce((sum, val) => sum + val, 0);
  const totalRecolectados = cantidadRecolectada.reduce((sum, val) => sum + val, 0);
  
  const chartOptions = {
    title: {
      text: "NFU reportados vs entregados",
      left: 'center',
      subtext: `TOTAL REPORTADA: ${totalReportados.toLocaleString()} | TOTAL ENTREGADA: ${totalRecolectados.toLocaleString()}`,
      subtextStyle: { fontWeight: 'bold', fontSize: '12px' },
    },
    tooltip: {
      confine: true,
      trigger: 'axis',
      formatter: params =>
        params[0].axisValueLabel + '<br/>' +
        params.map(param => `${param.marker} ${param.seriesName}: ${param.value.toLocaleString()} [U]`).join('<br/>')
    },
    legend: { data: ['Cantidad Reportada', 'Cantidad Entregada'], bottom: 0 },
    grid: { left: '3%', right: '4%', bottom: '60px', containLabel: true },
    xAxis: {
      type: 'category',
      data: mesesFormateados,
      axisLabel: { fontSize: 10, fontWeight: 'bold' }
    },
    yAxis: {
      type: 'value',
      name: '',
      axisLabel: { formatter: value => value.toLocaleString() }
    },
    series: [
      {
        name: 'Cantidad Reportada',
        type: 'line',
        data: cantidadReportada,
        color: 'black',
        symbolSize: 8,
        lineStyle: { width: 1.5 }
      },
      {
        name: 'Cantidad Entregada',
        type: 'line',
        data: cantidadRecolectada,
        color: '#BBCD21',
        symbolSize: 8,
        lineStyle: { width: 1.5 }
      }
    ]
  };
  
  return <EchartsWrapper options={chartOptions} style={{ width: "100%", height: "400px" }} />;
};

export default NfuVs;